module.exports = __webpack_public_path__ + "static/sunwing-logo-39612f435c71223198709da9c3d7d1b0.png";